module.exports = {"652824100":"若羌镇","652824101":"依吞布拉克镇","652824102":"罗布泊镇","652824103":"瓦石峡镇","652824104":"铁干里克镇","652824201":"吾塔木乡","652824203":"铁木里克乡","652824204":"祁曼塔克乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/652824.json
// module id = 3226
// module chunks = 0